import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DOCUMENT } from '../../constants/documentTheme';

const ENTRY_IDS = ['dmcPackages', 'inventoryAddons', 'membersSubgroups', 'profileEndpoint', 'itineraryDocuments', 'documentsPdf', 'v1Launch', 'webhooks', 'catalogWidget'];

const DeveloperChangelog = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography component="h1" sx={{ fontFamily: DOCUMENT.display, fontSize: { xs: 28, md: 34 }, mb: 0.75 }}>
        {t('developerPortal.changelog.title')}
      </Typography>
      <Typography sx={{ color: DOCUMENT.ink2, mb: 4, maxWidth: '62ch' }}>
        {t('developerPortal.changelog.subtitle')}
      </Typography>

      <Box
        sx={{
          mb: 4,
          pb: 3,
          borderBottom: `1px solid ${DOCUMENT.rule}`,
        }}
      >
        <Typography sx={{ fontFamily: DOCUMENT.display, fontSize: 22, mb: 0.5 }}>
          v1.0.0
        </Typography>
        <Typography sx={{ fontSize: 13, color: DOCUMENT.ink3, mb: 2 }}>2026-08-27</Typography>
        <Box component="ul" sx={{ m: 0, pl: 2.5, color: DOCUMENT.ink2, lineHeight: 1.7 }}>
          {ENTRY_IDS.map((id) => (
            <li key={id} style={{ marginBottom: 12 }}>
              <Typography component="span" sx={{ fontWeight: 600, color: DOCUMENT.ink }}>
                {t(`developerPortal.changelog.entries.${id}.title`)}
              </Typography>
              {' — '}
              {t(`developerPortal.changelog.entries.${id}.body`)}
            </li>
          ))}
        </Box>
      </Box>

      <Typography sx={{ fontSize: 14, color: DOCUMENT.ink3, maxWidth: '58ch' }}>
        {t('developerPortal.changelog.policy', {
          defaultValue: 'Current stable version is v1. Deprecated versions remain available until the Sunset date.',
        })}
      </Typography>
    </Box>
  );
};

export default DeveloperChangelog;
